<template>
  <div>
    <b-row class="match-height">
      <b-col
        lg="8"
        md="12"
        sm="12"
        class="mb-1"
      >
        <b-card
          no-body
          style="background-color: rgb(255, 127, 96, 0.0); width: 100% ;height: auto; border: 2px solid #00B058; border-radius: 4px 40px 4px 40px;"
        >
          <b-row>
            <b-col
              lg="8"
              class="d-flex align-items-center justify-content-start mt-1"
            >
              <b-img
                height="25"
                class="ml-1"
                src="@/assets/images/icons/CDroad/Graph2.svg"
              />
              <span
                class="ml-1"
                style="color:white; font-size: 16px;"
              >สถานะการทำงานโคมไฟล่าสุด</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
            >
              <AppEchartBar
                style="width:90%"
                :option-data="option"
              />
            </b-col>
          </b-row>

        </b-card>
      </b-col>
      <b-col
        lg="4"
        md="12"
        sm="12"
        class="mb-1"
      >
        <b-card
          no-body
          style="background-color: rgb(255, 127, 96, 0.0); width: 100% ;height: auto; border: 2px solid #00B058; border-radius: 4px 40px 4px 40px;"
        >

          <b-col
            class="d-flex align-items-center justify-content-start mt-1"
          >
            <b-img
              height="25"
              class="ml-1"
              src="@/assets/images/icons/CDroad/Graph2.svg"
            />
            <span
              class="ml-1"
              style="color:white; font-size: 16px;"
            >สถานะโคมไฟ</span>
          </b-col>
          <div class="chart ml-5">
            <app-echart-doughnut
              :series="series"
              :title="title"
              style="width:100%"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import * as echarts from 'echarts'
import AppEchartBar from './AppEchartBar.vue'
import AppEchartDoughnut from './AppEchartDoughnut.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    AppEchartBar,
    AppEchartDoughnut,
  },
  data() {
    return {
      statisticTitle: '',
      Total: '',
      color: '#00B058',
      items: [],
      activeButton: 0,
      option: {
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLabel: {
              color: '#fff',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false },
            axisLabel: {
              color: '#fff',
            },
          },
        ],
        grid: {
          width: '90%',
          height: '70%',
        },
        series: [
          {
            name: 'ใช้งานไม่ได้',
            type: 'bar',
            stack: 'advertising',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '40px',
            itemStyle: {
              barBorderRadius: [0, 0, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#989898' },
                { offset: 1, color: '#616161' },
              ]),
            },
          },
          {
            name: 'ใช้งานได้',
            type: 'bar',
            stack: 'advertising',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '40px',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFDB5E' },
                { offset: 1, color: '#FFB54B' },
              ]),
            },
          },
        ],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
      camTotal: '',
      title: {
        text: '',
        left: 'center',
        top: 'center',
        textStyle: {
          fontSize: 24,
          color: 'white',
        },
      },
      series: [
        {
          color: ['#00B058', '#FB0000'],
          name: 'Visit source',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          label: {
            show: true,
            fontSize: '14',
            formatter: ' {b}: {c} โคม ',
          },
          labelLine: {
            show: true,
          },
          data: [
            { value: '', name: 'ใช้งานได้' },
            { value: '', name: 'ใช้งานไม่ได้' },
          ],
        },
      ],
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getPieData()
    this.getbarChartCounting()
    setInterval(this.getNow, 1000)
    this.interval = setInterval(() => {
      this.getbarChartCounting()
      this.getPieData()
    }, 300000)
  },
  mounted() {
  },
  methods: {
    handle() {
      this.getPieData()
      this.getbarChartCounting()
    },
    getPieData() {
      axios
        .post('/getStatusSEM', { wid: this.$route.query.wid })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.title.text = `${response.data[0].available} ดวง`
          this.series[0].data[0].value = response.data[0].work
          this.series[0].data[1].value = response.data[0].fail
          // eslint-disable-next-line prefer-destructuring
        })
        .catch(error => {
          console.log(error)
        })
    },
    getbarChartCounting() {
      axios
        .post('/getChartWeekSEM', { wid: this.$route.query.wid })
        .then(response => {
          this.resetchart()
          this.xAxisData = []
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.option.xAxis[0].data.push(value.date_time)
            this.option.series[0].data.push(value.fail)
            this.option.series[1].data.push(value.work)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetchart() {
      this.option.xAxis[0].data.splice(0)
      this.option.series[0].data.splice(0)
      this.option.series[1].data.splice(0)
    },
  },
}
</script>

<style lang="scss" scpoed>
  </style>
